import { CountryRegionData } from "react-country-region-selector";

const stripDiacritics = (value = "") =>
  value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

/**
 * Map a saved state/region string to the exact label used by
 * react-country-region-selector (handles e.g. Punjab vs Punjāb).
 */
export const resolveRegion = (country, state) => {
  if (!country || !state) return state || "";

  const countryData = CountryRegionData.find(([name]) => name === country);
  if (!countryData?.[2]) return state;

  const regions = countryData[2].split("|").map((entry) => entry.split("~")[0]);
  if (regions.includes(state)) return state;

  const normalized = stripDiacritics(state);
  return regions.find((region) => stripDiacritics(region) === normalized) || state;
};
